module.exports = __webpack_public_path__ + "img/au_logo.7640f866.png";